import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { getUrlQuery } from 'shared/util/routing'

export class ReportRemoteViewContainer extends Component<any, any> {
  public UNSAFE_componentWillMount() {
    const query = getUrlQuery<any>({ location: this.props.location })

    const { sendUrl, silent } = query
    let redirectUrl = `${process.env.PS_VIEW_URL}/?&u=${sendUrl}`

    if (silent) {
      redirectUrl += `&s=${silent}`
    }

    // get email param from search
    const search = this.props.query
    if (search.e) {
      redirectUrl += `&e=${search.e}`
    }

    window.location.replace(redirectUrl)
  }

  // need a dummy render
  public render() {
    return <div />
  }
}

export default withRouter(ReportRemoteViewContainer)
